define([
    "./threeModule",
    "./ThreeRenderer",
    "./ThreeRenderLoop",
    "./threeMeshFactory",
    "./colorOfObject3D",
    "./threeEdgeFactory",
    "./OrthographicControl"
], function () {
});